import moment from 'moment'

import { formatDate } from '../../../App/Util'

import { IAbsenceRequest, IApiAbsenceRequest } from './IAbsenceRequest'
import {
    IAbsenceRequestStatistics,
    IApiAbsenceRequestStatistics,
} from './IAbsenceRequestStatistics'

class Transformer {
    static transform(data: IApiAbsenceRequest): IAbsenceRequest {
        return {
            id: data.id,
            person: {
                id: data.person.id,
                uuid: data.person.uuid,
                avatar: data.person.avatar,
                firstName: data.person.first_name,
                lastName: data.person.last_name,
                fullName: data.person.full_name,
            },
            startsAt: moment(data.starts_at),
            endsAt: moment(data.ends_at),
            type: data.type,
            reason: data.reason ? data.reason : undefined,
            status: data.status,
            reviewReason: data.review_reason ? data.review_reason : undefined,
        }
    }

    static reverseTransform(
        absenceRequest: IAbsenceRequest
    ): IApiAbsenceRequest {
        const startAtDate = formatDate(
            absenceRequest.startsAt,
            'FORMAT_DATE_API'
        )
        const startAtTime = formatDate(
            absenceRequest.startsAt,
            'FORMAT_TIME_API'
        )
        const endsAtDate = formatDate(absenceRequest.endsAt, 'FORMAT_DATE_API')
        const endsAtTime = formatDate(absenceRequest.endsAt, 'FORMAT_TIME_API')

        const APIAbsence: IApiAbsenceRequest = {
            id: absenceRequest.id,
            person: {
                id: absenceRequest.person.id,
                uuid: absenceRequest.person.uuid,
                avatar: absenceRequest.person.avatar,
                first_name: absenceRequest.person.firstName,
                last_name: absenceRequest.person.lastName,
                full_name: absenceRequest.person.fullName,
            },
            starts_at: `${startAtDate} ${startAtTime}`,
            ends_at: `${endsAtDate} ${endsAtTime}`,
            type: absenceRequest.type,
            reason: absenceRequest.reason ? absenceRequest.reason : undefined,
            status: absenceRequest.status,
            review_reason: absenceRequest.reviewReason
                ? absenceRequest.reviewReason
                : undefined,
        }

        if (null !== absenceRequest.id) {
            APIAbsence.id = absenceRequest.id
        }
        return APIAbsence
    }

    static transformStatistic(
        data: IApiAbsenceRequestStatistics
    ): IAbsenceRequestStatistics {
        return {
            ...data,
            personUuid: data.person_uuid,
        }
    }
}

export default Transformer
